import React from 'react';

const NemwelEducation = () => (
  <div className="NemwelEducation">
    <div className="edu">
      <h2>AWS Cloud Practitioner</h2>
      <h3>April 2024 - Aug 2024</h3>
      <h4> eMobilis Institute, Nairobi</h4>
      <p>
        Completed full-time, classroom-based skills development and training
        program on IT fundamentals, AWS Cloud, and professional skills Built
        IT fundamental skills, including working knowledge of Linux OS, and
        writing scripts in Python and Shell Learned how to apply core AWS services
        in the areas of computing, storage, and networking; including EC2, S3,
        IAM, VPC, Lambda, Cloud Formation, RDS, and Route 53 Demonstrated strong
        verbal and written communication skills, including the ability to explain
        technical information and terminology to non-technical end users Learned how
        to configure, monitor, and support the suite of core AWS services
      </p>
      <p>
        <span>Status:</span>
        {' '}
        Completed.
      </p>
    </div>

    <div className="edu">
      <h2>Full Stack Web Development</h2>
      <h3>Jan 2022 - Aug 2022</h3>
      <h4>MICROVERSE, San Francisco, US</h4>
      <p>
        Spent 1300+ hours mastering algorithms, data structures, and full-stack
        development while simultaneously developing projects with JavaScript, React,
        Redux, Ruby, and Ruby on Rails. Developed skills in remote pair programming
        using GitHub, industry-standard git-flow, and daily standups to communicate
        and collaborate with international remote developers.
      </p>
      <p>
        <span>Status:</span>
        {' '}
        Completed.
      </p>
    </div>

    <div className="edu">
      <h2>Bachelor of Business Information Technology</h2>
      <h3>Sept 2019 - Dec 2024</h3>
      <h4>KCAU, Nairobi, Kenya</h4>
      <p>
        Gained skills in programming, such as systems analysis and design, database
        administration, and accounting principles —e.g.,  quick books. Pioneered the
        launch of the IT club on campus which has grown to over 30 members.
      </p>
      <p>
        <span>Status:</span>
        {' '}
        Completed.
      </p>
    </div>
  </div>
);

export default NemwelEducation;
